import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@scripts/woo_services.module/AuthService';
import { OMS_BOOKABLE_CHECK_ENABLED } from '@scripts/woo_services.module/shared-types';
import { SystemService } from '@scripts/woo_services.module/SystemService';

const LEGACY_PATH = '/buylist';
const OMS_PATH = '/buylist-oms';

@Injectable({ providedIn: 'root' })
class BuylistOmsToggleRedirect {
  private systemService = inject(SystemService);
  private authService = inject(AuthService);
  private router = inject(Router);

  async toOmsWhenEnabled(): Promise<boolean> {
    // AuthGuard already rejects; avoid a late redirect once settings load after login
    if (!this.authService.isAuthenticated()) {
      return false;
    }
    if (this.authService.admin()) {
      return true;
    }
    const enabled = await this.systemService.isFeatureToggleOn(OMS_BOOKABLE_CHECK_ENABLED);
    return enabled ? this.redirect(OMS_PATH) : true;
  }

  async toLegacyWhenDisabled(): Promise<boolean> {
    if (!this.authService.isAuthenticated()) {
      return false;
    }
    if (this.authService.adminOrPlanner()) {
      return true;
    }
    const enabled = await this.systemService.isFeatureToggleOn(OMS_BOOKABLE_CHECK_ENABLED);
    return enabled || this.redirect(LEGACY_PATH);
  }

  private redirect(url: string): boolean {
    const state = this.router.getCurrentNavigation()?.extras.state;
    void this.router.navigateByUrl(url, { state, replaceUrl: true });
    return false;
  }
}

export const RedirectBuylistToOmsGuard: CanActivateFn = () => inject(BuylistOmsToggleRedirect).toOmsWhenEnabled();

export const RedirectBuylistOmsToLegacyGuard: CanActivateFn = () =>
  inject(BuylistOmsToggleRedirect).toLegacyWhenDisabled();
